import { FlexColumn, FlexRow, LabeledData, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { HeadingXSmall } from 'baseui/typography';
import { useStyles } from '../../hooks/useStyles';
import { SubClient } from '../../types/subClient';
import StyledTooltip from '../ui/StyledTooltip';

type Props = {
  subClient: SubClient;
  onEnabledEditingMode: (editingMode: boolean) => void;
};
export function SubClientInfo({ subClient, onEnabledEditingMode }: Readonly<Props>) {
  const { css, theme } = useStyles();
  const labelWidth = '190px';

  return (
    <FlexColumn>
      <FlexRow
        classNames={`${css({
          alignItems: 'center',
          justifyContent: 'space-between',
          minHeight: theme.sizing.scale950,
        })}`}
      >
        <HeadingXSmall margin={0}>Generales</HeadingXSmall>
        <StyledTooltip
          content={'Editar'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={() => onEnabledEditingMode(true)}
            kind="tertiary"
          >
            <MaterialIcon
              name={'edit'}
              size="xs-mini"
            />
          </Button>
        </StyledTooltip>
      </FlexRow>
      <LabeledData
        label="Nombre:"
        content={subClient.name}
        labelWidth={labelWidth}
      />
      <LabeledData
        label="Nombre comercial:"
        content={subClient.tradeName}
        labelWidth={labelWidth}
      />
      <LabeledData
        label="RFC:"
        content={subClient.rfc}
        labelWidth={labelWidth}
      />
      <LabeledData
        label="Estado:"
        content={subClient.active ? 'Activo' : 'Inactivo'}
        labelWidth={labelWidth}
      />
      <HeadingXSmall margin={0}>Contacto de emergencia</HeadingXSmall>
      <LabeledData
        label="Nombre:"
        content={subClient.contact?.fullName}
      />
      <LabeledData
        label="Correo:"
        content={subClient.contact?.email}
      />
      <LabeledData
        label="Teléfono:"
        content={subClient.contact?.phone}
      />
      <HeadingXSmall margin={0}>Torre de control</HeadingXSmall>
      <LabeledData
        label="Activo:"
        content={subClient.controlTower ? 'Sí' : 'No'}
        labelWidth={labelWidth}
      />
      {subClient.controlTower &&
        subClient.controlTowerScalingMatrix?.map((scalingMatrix, i) => {
          return (
            <FlexColumn
              key={i}
              gap={'4px'}
              classNames={css({
                borderTop: '1px solid lightGray',
                paddingTop: '1em',
              })}
            >
              <LabeledData
                label={'Nombre'}
                content={scalingMatrix.name}
              />
              <LabeledData
                label={'Minutos'}
                content={`${scalingMatrix.minutes}min.`}
              />
              <LabeledData
                label={'Telefono'}
                content={scalingMatrix.phone}
              />
            </FlexColumn>
          );
        })}
    </FlexColumn>
  );
}
